export default __webpack_public_path__ + "static/media/POS2.39c4bb17.png";